import type { RouteObject } from "react-router-dom";
import FlashPage from "../flash/FlashPage";
import site from "../flash/site.json";

// Flash 站的路由：一个页面对应 site.json 里的一页，路径由生成流程决定。
const routes: RouteObject[] = [
  // the "notfound" page in site.json uses path "*" so invalid routes keep the shared header/footer
  ...site.pages.map((page) => ({
    path: page.path,
    element: <FlashPage page={page} />,
  })),
];

export default routes;
